import styles from '../views/Dashboard/Applicants/css/display-applicant.module.css';
import {AiOutlineSearch as SearchIcon} from 'react-icons/ai';
import {IoReload as ReloadIcon} from 'react-icons/io5';



export const SearchForm = (props:any) =>{
    const className = props.className? `${props.className} ${styles.searchForm}`:styles.searchForm;
    return(
        <form className={className} {...props} ><span className={styles.sI}><SearchIcon/></span><input type="text" placeholder='Search' /><button className={styles.rBtn} type="submit"><ReloadIcon/></button></form>
    )
}